// Widget Scripts
import initCountdown from './js/widgets/00-numericCountdown.js';
import createHeroBanner from './js/widgets/0B-createHeroBanner.js';
import headerTopItems from './js/widgets/0C-headerTopItems.js';
import headerButton from './js/widgets/0D-ticketButton.js';
import homepagePopUp from './js/widgets/0A-homepagePopUp.js';

import * as mainFeature from './js/widgets/2-mainFeature/index.js';
import * as eventsWidget from './js/widgets/3-events-widget/index.js';

import customSeoBlock from './js/widgets/4-customSeoBlock.js';
import customCards from './js/widgets/5-customCards.js';
import innerPageCustomCards from './js/widgets/5B-innerPageCustomCards.js';
import cardStats from './js/widgets/6-cardStats.js';
import brandingCards from './js/widgets/7-brandingCards.js';
import scrollerSponsors from './js/widgets/8-scrollerSponsors.js';
import footerLinks from './js/widgets/9-footerLinks.js';
import customSignup from './js/widgets/9B-customSignup.js';

// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets
$(document).ready(function () {
  initCountdown();
  headerButton();
  headerTopItems();
  createHeroBanner();
  customSignup();
  footerLinks();
  homepagePopUp();
  scrollerSponsors();
  innerPageCustomCards();

  if (globalThis.location.pathname === '/') {
    mainFeature.firstHeadline();
    mainFeature.secondHeadline();
    mainFeature.vimeoFeature();

    // eventsWidget.autoEventFeed();
    eventsWidget.manualEventFeed();

    customSeoBlock();
    customCards();
    cardStats();
    brandingCards();
  }

  $(globalThis).on('load', function () {});
});
